import React from 'react';
import {useDispatch} from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";

const IFCLookupList_Item = ({ifcData}) => {
    const dispatch = useDispatch();

    const viewItemDetails = (item) => {
        dispatch({
            type: actionTypes.MODAL_IFC_LOOKUP_SHOW,
            ifcData: item
        });
    };

    return (
        <tr>
            <td style={{ maxWidth: '300px' }} className="text-truncate">{ifcData.description}</td>
            <td style={{ maxWidth: '100px' }}>{ifcData.itemNumber}</td>
            <td style={{ maxWidth: '80px' }}>{ifcData.dayOrOvernight}</td>
            <td style={{ maxWidth: '80px' }}>{ifcData.mplAhmDrg}</td>
            <td style={{ maxWidth: '80px' }}>{ifcData.ahsaDrg}</td>
            <td style={{ maxWidth: '80px' }}>{ifcData.bupaDrg}</td>
            <td style={{ maxWidth: '80px' }}>{ifcData.publicDrg}</td>
            <td style={{ maxWidth: '100px' }}>{ifcData.prosthesisCode}</td>
            <td style={{ maxWidth: '60px' }} className="text-right">
                <button className="p-0 text-blue-600 hover:text-blue-800 btn-reset-filter" onClick={() => viewItemDetails(ifcData)}>View</button>
            </td>
        </tr>
    )
}

export default IFCLookupList_Item;